/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_NetInputs */

const en_cargos_sales_range_net = /** @type {(inputs: Cargos_Sales_Range_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net sold`)
};

const es_cargos_sales_range_net = /** @type {(inputs: Cargos_Sales_Range_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venta neta`)
};

/**
* | output |
* | --- |
* | "Net sold" |
*
* @param {Cargos_Sales_Range_NetInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_net = /** @type {((inputs?: Cargos_Sales_Range_NetInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_NetInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_net(inputs)
	return es_cargos_sales_range_net(inputs)
});